import React from 'react';
import PropTypes from 'prop-types';
import * as pageTypes from 'shared/pageTypes';

const { FACILITY_LINK, FACILITY_LISTING, FACILITY_PAGE } = pageTypes;

const propTypes = {
  facility: PropTypes.object,
  metadata: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
};

const PageType = ({ metadata: { type }, facility }) => {
  const types = {
    BLOG_CATEGORY_PAGE: 'Blog Category',
    BLOG_HOME_PAGE: 'Blog Home',
    BLOG_PAGE: 'Blog Post',
    HOME_PAGE: 'Home',
    MISC_PAGE: 'Misc',
    FACILITY_LINK: 'Facility: Link Out',
    FACILITY_LISTING: 'Facility: Listing',
    FACILITY_PAGE: 'Facility',
    FACILITIES_LIST_PAGE: 'All Facilities',
    PRIVACY_PAGE: 'Privacy',
    TERMS_PAGE: 'Terms and Conditions',
    PAY_ONLINE_PAGE: 'Pay Online',
    PAGE_LAYOUT: 'Page Layout',
  };

  const pageTypeKey = Object.keys(pageTypes).find(key => pageTypes[key] === type);
  const pageType = pageTypes[pageTypeKey];
  const isFacilityPage = [FACILITY_LINK, FACILITY_LISTING, FACILITY_PAGE].includes(pageType);
  const isMissingFacility = isFacilityPage && !facility;

  return (
    <div>
      {isMissingFacility ? 'Facility: Missing Facility' : types[pageTypeKey]}
    </div>
  );
};

PageType.propTypes = propTypes;

export default PageType;
